export const RESIDENT_MEDICATIONS_QUERY_KEY = 'resident-medications'
export const RESIDENT_MEDICATIONS_URL =
  '/emar/medication-stock-records/overview'

export const STOCK_LOGS_QUERY_KEY = 'stock-records'
export const STOCK_LOGS_URL = '/emar/medication-stock-records/list'

export const CURRENT_STOCK_QUERY_KEY = 'current-stock'
export const CURRENT_STOCK_URL = '/emar/medication-stock-records'
export const CURRENT_STOCK_PATH = 'current-stock'

export const STOCK_COUNT_URL = '/emar/medication-stock-records/stock-count'
export const ADD_STOCK_BATCH_URL =
  '/emar/medication-stock-records/delivery/batch'
export const DISPOSAL_URL = '/emar/medication-stock-records/disposal'
export const UPDATE_STOCK_RECORD_URL = '/emar/medication-stock-records'

export const MAR_CHART_QUERY_KEY = 'mar-chart'
export const MAR_CHART_URL =
  '/emar/medication-administration-instances/mar-chart'

export const STOCK_DASHBOARD_SUMMARY_QUERY_KEY = 'stock-dashboard-summary'
export const STOCK_DASHBOARD_SUMMARY_URL =
  '/emar/medication-administration-instances/dashboard-card'

export const STOCK_DISCREPANCIES_QUERY_KEY = 'stock-discrepancies'
export const STOCK_DISCREPANCIES_URL =
  '/emar/medication-stock-records/discrepancies'
export const RESOLVE_DISCREPANCY_URL =
  '/emar/medication-stock-records/resolve-discrepancy'

export const MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY =
  'medication-schedule-patterns'
export const MEDICATION_SCHEDULE_PATTERNS_URL =
  '/emar/medication-schedule-patterns/resident'
export const MEDICATION_SCHEDULE_PATTERN_QUERY_KEY =
  'medication-schedule-pattern'
export const MEDICATION_SCHEDULE_PATTERN_URL =
  '/emar/medication-schedule-patterns'

export const MEDICATION_SCHEDULE_PATTERN_DISCONTINUE_URL =
  '/emar/medication-schedule-patterns/{id}/discontinue'
export const MEDICATION_SCHEDULE_PATTERN_DISCONTINUE_QUERY_KEY =
  'medication-schedule-pattern-discontinue'
